import React from "react";
import "./styles.css";
import { Glyphicon } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import cookie from "react-cookies";
import { downloadReport } from "../../common/sysco-ui-components/services/commonServices";
import {  env } from "../../common/sysco-ui-components/config/constant";
import { Spin } from "antd";
import CheckDetailsContainer from "../../containers/checkDetailsContainer";
import DocumentView from "../documentView";
import { SyncOutlined } from "@ant-design/icons";
import { SUPPLIER_PATH } from "../../config/path";
class supplierWeb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recentIcon: true,
      reportIcon: true,
      vendorDownloadIcon: true
    };
  }

  itemHide = item => {
    if (item === "recentChecks") {
      this.setState({
        recentIcon: !this.state.recentIcon
      });
    } else if (item === "payableReport") {
      this.setState({
        reportIcon: !this.state.reportIcon
      });
    } else if (item === "vendorDownload") {
      this.setState({
        vendorDownloadIcon: !this.state.vendorDownloadIcon
      });
    }
  };

  issueClick = id => {
    this.props.OnAddTab(`Daily Trial Balance:${id}`,DocumentView,{"id":id});
    // history.push(`/daily-trial-balance/${id}`);
  };
  componentDidMount() {
    cookie.remove("sessionOut",{ path: '/' });
    document.getElementById("headerMain").classList.remove("loginclass");
    document.getElementById("antTab").classList.remove("loginclass");
    // this.props.getDashboard();
  }

  handleDate = (date, name) => {
    this.setState({ [name]: date });
  };

  checkDetailsNav = data => {

    // let docCat=(data.docCat && data.docCat.length!=0) ? data.docCat.filter(val=>val.catName=="BSCC AP Payment"):[]

    // let vendorNo=docCat.length!=0?docCat[0].catAttrs.filter(val=>val.attrName=="Vendor Number")[0].attrValues:''
    // let checkNo=docCat.length!=0?docCat[0].catAttrs.filter(val=>val.attrName=="Check ACH Number" || val.attrName=="Check/ACH Number")[0].attrValues:''
    this.props.OnAddTab(
      `Check Details:${data.checkNumber}`,CheckDetailsContainer,{docId:data.nodeId,vendorNo:data.vendorNumber,checkNo:data.checkNumber}
    );
    // history.push(`/checkdetails/${data.nodeId}/${data.vendorNumber}/${data.checkNumber!=""?data.checkNumber:'null'}`);
  };

  getRecentRows = () => {
    let recentCheck = [];
    let temp = [];
    let count = 0;
    for (let i = 0; i < this.props.recentChecks.length; i++) {
      temp.push = (
        <div className="dataContent">
          {i + 1}.{" "}
          <a  href='javascript:void(0)' onClick={this.checkDetailsNav}>
            {" "}
            Check#: {this.props.recentChecks[i].docId}
          </a>
        </div>
      );
      if (count + 1 === 5 || this.props.recentChecks.length === i + 1) {
        recentCheck.push(<div className={"abcd"}>{temp}</div>);
        temp = [];
        count = 0;
      } else {
        count += 1;
      }
    }
    return recentCheck;
  };
  downloadVendorReport = data => {
    downloadReport(
      `/download?docId=${data.nodeId}`, `vendorReport_${data.label}.zip`, "GET", "", SUPPLIER_PATH
    );
  };
  render() {
    return (
      <div style={{ backgroundColor: "#b3c2cc !important" }}>
        <div className="tableContent  tabViewContent">
          <div
            className={
              this.state.recentIcon === true ? "tablebox2" : "tableminus"
            }
          > 
           <Spin spinning={this.props.recentLoader} tip="Loading...">

           <div style={{display:"flex",justifyContent:"space-between"}}> <div className="tableheading">
              Recent Checks (
              {this.props.recentChecks?this.props.recentChecks.length:0}
              )
              <Glyphicon
                style={{ float: "right", color: "grey", paddingTop: "0.2%" }}
                className={
                  this.state.recentIcon === true
                    ? "glyphicon-triangle-bottom"
                    : "glyphicon-triangle-left "
                }
                onClick={() => {
                  this.itemHide("recentChecks");
                }}
              />
            </div>
            <SyncOutlined className="refreshStyle"
              onClick={event => {
                event.stopPropagation();
                this.props.getRecentChecks(localStorage.getItem("subvendorList")) }}
            /></div>
            <div
              style={
                this.props.recentChecks.length != 0
                  ? {
                      gridAutoFlow: "column",
                      display: "grid",
                      gridTemplate: `repeat(${
                        Math.ceil(
                          this.props.recentChecks.length / 7 /* no of columns*/
                        ) < 5 /* no of rows*/
                          ? 5 /* no of rows*/
                          : Math.ceil(
                              this.props.recentChecks.length /
                                7 /* no of columns*/
                            )
                      }, 1fr) / repeat(7, 1fr)`
                    }
                  : {}
              }
            >
              {" "}
              {this.state.recentIcon ? (
                this.props.recentChecks.length ? (
                  this.props.recentChecks.map((item, i) => {
                    // let docCat=(item.docCat && item.docCat.length!=0) ? item.docCat.filter(val=>val.catName=="BSCC AP Payment"):[]
                    // let rcNo=docCat.length!=0 ? docCat[0].catAttrs.filter(val=>val.attrName=="Check ACH Number" || val.attrName=="Check/ACH Number"):""
                  // /  Check#: {rcNo.length!=0 ?rcNo[0].attrValues:""}
                    return (
                      <div className="dataContent">
                        {i + 1}.{" "}
                        <a href='javascript: void(0)' onClick={() => this.checkDetailsNav(item)}>
                          {" "}
                          Check#: {item.checkNumber}
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className="dataContent" style={{color:"black"}}>There are no Recent Checks available.</div>
                )
              ) : null}
            </div>
          </Spin>
          </div>
          <div
            className={
              this.state.reportIcon === true ? "tablebox2" : "tableminus"
            }
          >
              <Spin spinning={this.props.dailyLoader} tip="Loading...">
              <div style={{display:"flex",justifyContent:"space-between"}}> <div className="tableheading">
              Daily Pending Payable Report (
              {this.props.dailyPendingPayablesReport?
                this.props.dailyPendingPayablesReport.length:0}
              )
              <Glyphicon
                style={{ float: "right", color: "grey", paddingTop: "0.2%" }}
                className={
                  this.state.reportIcon === true
                    ? "glyphicon-triangle-bottom"
                    : "glyphicon-triangle-left "
                }
                onClick={() => {
                  this.itemHide("payableReport");
                }}
              />
            </div>
            <SyncOutlined className="refreshStyle"
              onClick={event => {
                event.stopPropagation();
                this.props.getPendingPayableReport(localStorage.getItem("subvendorList")) }}
            /></div>
            <div>
              {" "}
              {this.state.reportIcon ? (
                <div
                  style={
                    this.props.dailyPendingPayablesReport.length != 0
                      ? {
                          gridAutoFlow: "column",
                          display: "grid",
                          gridTemplate: `repeat(${
                            Math.ceil(
                              this.props.dailyPendingPayablesReport.length /
                                4 /* no of columns*/
                            ) < 5 /* no of rows*/
                              ? 5 /* no of rows*/
                              : Math.ceil(
                                  this.props.dailyPendingPayablesReport.length /
                                    4 /* no of columns*/
                                )
                          }, 1fr) / repeat(4, 1fr)`
                        }
                      : {}
                  }
                >
                  {this.props.dailyPendingPayablesReport.length ? (
                    this.props.dailyPendingPayablesReport.map((item, i) => {
                      // let docCat1=(item.docCat && item.docCat.length!=0) ? item.docCat.filter(val=>val.catName=="BSCC AP Reporting"):[]
                      // let dpNo=docCat1.length!=0 ? docCat1[0].catAttrs.filter(val=>val.attrName=="Vendor Number"):""
                      // dpNo.length!=0 ?dpNo[0].attrValues:""
                      return (
                        <div className="dataContent">
                          <a
                            href="javascript:void(0)"
                            onClick={() => this.issueClick(item.nodeId)}
                            // className="atag"
                          >
                            {`Pending Payables Report #${i + 1}: (${
                              item.vendorNumber
                            })`}
                          </a>
                        </div>
                      );
                    })
                  ) : (
                    <div className="dataContent" style={{color:"black"}} >There are no Pending Payables Reports available.</div>
                  )}
                </div>
              ) : null}
            </div>
            </Spin>
          </div>
          <div
            className={
              this.state.vendorDownloadIcon === true
                ? "tablebox2"
                : "tableminus"
            }
          >
              <Spin spinning={this.props.vendorLoader} tip="Loading...">
              <div style={{display:"flex",justifyContent:"space-between"}}> <div className="tableheading">
              Vendor Download Link (
              {this.props.vendorDownloadLinks?
                this.props.vendorDownloadLinks.length:0}
              )
              <Glyphicon
                style={{ float: "right", color: "grey", paddingTop: "0.2%" }}
                className={
                  this.state.vendorDownloadIcon === true
                    ? "glyphicon-triangle-bottom"
                    : "glyphicon-triangle-left "
                }
                onClick={() => {
                  this.itemHide("vendorDownload");
                }}
              />
            </div>
            <SyncOutlined className="refreshStyle"
              onClick={event => {
                event.stopPropagation();
                this.props.getVendorDownloadLinks(localStorage.getItem("vendorNumber"))}}
            /></div>
          
            <div
              style={
                this.props.vendorDownloadLinks.length != 0
                  ? {
                      gridAutoFlow: "column",
                      display: "grid",
                      gridTemplate: `repeat(${
                        Math.ceil(
                          this.props.vendorDownloadLinks.length /
                            9 /* no of columns*/
                        ) < 5 /* no of rows*/
                          ? 5 /* no of rows*/
                          : Math.ceil(
                              this.props.vendorDownloadLinks.length /
                                9 /* no of columns*/
                            )
                      }, 1fr) / repeat(9, 1fr)`
                    }
                  : {}
              }
            >
              {" "}
              {this.state.vendorDownloadIcon ? (
                this.props.vendorDownloadLinks.length ? (
                  this.props.vendorDownloadLinks.map((item, i) => {
                    // <div>{this.getRecentRows()}</div>
                    //onClick={() => this.downloadVendorReport(item)}
                    return (
                      <div className="dataContent">
                        {i + 1}.{" "}
                        <a  href={`https://les${env()}.sysco.com/otcs/cs.exe/api/v1/nodes/${
             item.nodeId
        }/content?OTDSTicket=${cookie.load("serviceToken")}`} >
                          {" "}
                          {item.label}
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className="dataContent" style={{color:"black"}}>There are no Vendor Documents available.</div>
                )
              ) : null}
            </div>
            </Spin>
          </div>
        </div>
      </div>
    );
  }
}

export default supplierWeb;
